import { sanitizeHtml } from "@/utils/sanitizeHtml";

const AirBannerContent = ({ title, content }) => {
  return (
    <>
      <h1 className="mb-4 text-2xl font-bold max-[768px]:mb-2 max-[768px]:text-base">
        {title}
      </h1>
      {content.map((cont, i) => (
        <p
          key={i}
          className="my-4 first:mt-6 last:mb-6 max-[768px]:text-sm"
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(cont) }}
        />
      ))}
    </>
  );
};

export default AirBannerContent;
